import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';

const routes: Routes = [
  { path: '', redirectTo: '/auth/login', pathMatch: 'full' },
  { 
    path: 'auth', 
    loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule) 
  },
  { 
    path: 'playlists', 
    loadChildren: () => import('./features/playlists/playlists.module').then(m => m.PlaylistsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'player',
    loadChildren: () => import('./features/player/player.module').then(m => m.PlayerModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'ai-playlists',
    loadChildren: () => import('./features/ai-playlists/ai-playlists.module').then(m => m.AIPlaylistsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'listening-history',
    loadChildren: () => import('./features/listening-history/listening-history.module').then(m => m.ListeningHistoryModule),
    canActivate: [AuthGuard]
  },
  { path: '**', redirectTo: '/auth/login' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }